// extracted by mini-css-extract-plugin
module.exports = {"fileTransfer":"styles_fileTransfer__KJqi8","button":"styles_button__QmSfY"};